import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, SelectionList, } from '@dixa/lib-shared-habla';
import { Fragment, memo, useCallback, useRef } from 'react';
import { useMount } from 'react-use';
import { analytics } from 'app/utils/segment';
import { useCommands } from 'utils/commands';
import { copilotActions, } from '../../../../utils';
import { CopilotSelectionListItemContent } from './components';
/** Represents a {@link SelectionList} containing copilot actions. */
export const CopilotSelectionList = memo(function CopilotSelectionList({ onChange, }) {
    const { keybindings } = useCommands();
    const selectionListRef = useRef(null);
    const handleChange = useCallback((event) => {
        analytics.agentCopilotDropdownItemClicked({
            key: event.selectedItem.value,
        });
        onChange(event.selectedItem.value);
    }, [onChange]);
    useMount(() => {
        requestAnimationFrame(() => {
            var _a;
            (_a = selectionListRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    });
    return (_jsx(SelectionList, Object.assign({ onChange: handleChange, ref: selectionListRef }, { children: Object.entries(copilotActions).map((entry, index) => {
            const name = entry[0];
            const { icon, title, commandName, hasDividerBefore } = entry[1];
            const item = (_jsx(SelectionList.Item, Object.assign({ value: name, noFixedSelectionStateSpace: true }, { children: _jsx(CopilotSelectionListItemContent, { icon: icon, title: title, keyCombinations: commandName && keybindings[commandName] }) }), `${index}-item`));
            if (!hasDividerBefore) {
                return item;
            }
            return (_jsxs(Fragment, { children: [_jsx(Divider, {}), item] }, `${index}-fragment`));
        }) })));
});
